<div class="flex flex-row gap-4 align-middle w-full py-2 pl-4 bg-[#182256] border-t-2 border-white ">

    <div class="flex flex-row align-middle flex-wrap items-center gap-3 cursor-pointer mb-0">
      <ng-container *ngFor="let menuItem of items">
        <app-submenu-item [item]="menuItem"></app-submenu-item>
      </ng-container>
    </div>

</div>
<ng-container *ngIf="!isHide">
  <div class="flex flex-row justify-start items-center pl-5 pt-2 gap-1" [ngClass]="{'bg-[#f6f6f6]': backBgGray}">
    <div class="flex gap-1 cursor-pointer" (click)="goBack()">
      <img class="w-fit box-border h-4" src="assets/icons/Arrow 1.png" alt="icon-arrow">
      <p class="text-[#5B6563] font-medium text-xs">Volver</p>
    </div>
  </div>
</ng-container>

